import { useState, useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { PriorityLevel } from './types';
import { FrEventFormType } from '../../fr-entity-panels/types';
import { globalAttributes } from '../../common/global-attributes';

export function useEventPriority() {
    const [level, setLevel] = useState<PriorityLevel>(4);
    const { control } = useFormContext<FrEventFormType>();
    const eventPriority = useWatch({ control, name: 'priority' });

    useEffect(() => {
        if (!eventPriority?.parentAttributeId) {
            return;
        }

        const level = eventPriority.parentAttributeId % 100;

        if (level && level > 0) {
            setLevel(level > 4 ? 4 : level);
        }
    }, [eventPriority]);

    return { label: eventPriority?.label, level };
}

export function useRiskLevel() {
    const [level, setLevel] = useState<PriorityLevel>(4);
    const { control } = useFormContext<FrEventFormType>();
    const riskLevel = useWatch({ control, name: 'riskLevel' });
    const { eventsHaveRiskLevel } = useEnabledFeatures();

    useEffect(() => {
        if (!eventsHaveRiskLevel || !riskLevel?.parentAttributeId) {
            return;
        }

        const level =
            Object.values(globalAttributes.riskLevelGlobal)
                .reverse()
                .findIndex(
                    (parentAttributeId) => parentAttributeId === riskLevel.parentAttributeId
                ) + 1;

        if (level && level > 0) {
            setLevel(level > 4 ? 4 : level);
        }
    }, [riskLevel, eventsHaveRiskLevel]);

    if (!eventsHaveRiskLevel) {
        return null;
    }

    return { label: riskLevel?.label, level };
}
